import { Dialog } from "primereact/dialog"
import _ from "lodash"
import { Slider } from "primereact/slider"
import React from "react"
import { useDispatch } from "react-redux"

import { Button, DropDownField, InputSwitchField, TextInputField } from "../../../helpers"
import Tooltip from "../../../helpers/Tooltip"
import { confirmDialog } from "primereact/confirmdialog"

import { calculateBuyerQuotation, getProductName, getProductSpecification, numberConversion, round } from "../../../utils"

import { raiseToast } from "../../../services/redux/reducers/toast/toast"


const BuyerQuoteMarginSuggetions = (props) => {
    const {
        buyerQuote,
        pmCompanyConfig,
        visibleMarginSuggestion,
        setVisibleMarginSuggestion,
        buyerQuoteItems,
        buyerReqItems,
        materialDetails,
        suggMarginBuyerQuoteItems,
        setSuggMarginBuyerQuoteItems,
        suggMarginBuyerQuote,
        setsuggMarginBuyerQuote,
        handleUpdatedBuyerQuoteItemsSuggMargins,
        getMarginCalc,
        getUnitPriceCalc,
        getBuyerQuoteItemProfit,
        skipSuggMarginReasons,
        setBuyerQuote
    } = props

    const numberLocale = pmCompanyConfig.numberLocale

    const dispatch = useDispatch()

    const updateBuyerQuoteItemsWithSuggValues = (updatedSuggMarginBuyerQuoteItems) => {
        const allBuyerQuoteItems = buyerQuoteItems.map(eachQuoteItem => {
            const relatedSuggMarginBuyerQuoteItem = updatedSuggMarginBuyerQuoteItems.find(eachSuggMarginBuyerQuoteitem => eachSuggMarginBuyerQuoteitem.buyerQuoteItemId === eachQuoteItem.buyerQuoteItemId)
            if (relatedSuggMarginBuyerQuoteItem) {
                return relatedSuggMarginBuyerQuoteItem
            }
            return eachQuoteItem
        })
        const calculatedResult = calculateBuyerQuotation(suggMarginBuyerQuote, allBuyerQuoteItems)

        let isSuggMarginApplied = false
        updatedSuggMarginBuyerQuoteItems = updatedSuggMarginBuyerQuoteItems.map(eachSuggMarginBuyerQuoteItem => {
            if (eachSuggMarginBuyerQuoteItem.bQuotMarginRate > eachSuggMarginBuyerQuoteItem.quotedMargin) {
                isSuggMarginApplied = true
            }
            const relatedBuyerQuoteItem = calculatedResult.buyerQuoteItems.find(eachBuyerQuoteItem => eachSuggMarginBuyerQuoteItem.buyerQuoteItemId === eachBuyerQuoteItem.buyerQuoteItemId)
            if (relatedBuyerQuoteItem) {
                const relatedBuyerQuoteItems = calculatedResult.buyerQuoteItems.filter(eachBuyerQuoteItem => eachBuyerQuoteItem.buyerReqItemId === relatedBuyerQuoteItem.buyerReqItemId)
                const suggMarginProfit = getBuyerQuoteItemProfit(relatedBuyerQuoteItems)

                return {
                    ...eachSuggMarginBuyerQuoteItem,
                    suggMarginProfit: suggMarginProfit,
                    bQuotSellerDiscountRate: relatedBuyerQuoteItem.bQuotSellerDiscountRate,
                    bQuotDiscountRate: relatedBuyerQuoteItem.bQuotDiscountRate,
                    bQuotMarginRate: relatedBuyerQuoteItem.bQuotMarginRate,
                    bQuotUnitPrice: relatedBuyerQuoteItem.bQuotUnitPrice,
                    bQuoteItemAmountBeforeTax: relatedBuyerQuoteItem.bQuoteItemAmountBeforeTax,
                    bQuoteItemAmountWithTax: relatedBuyerQuoteItem.bQuoteItemAmountWithTax,
                    bQuoteItemTaxAmount: relatedBuyerQuoteItem.bQuoteItemTaxAmount,
                    bestAvgSellerPrice: relatedBuyerQuoteItem.bestAvgSellerPrice,
                    avgSellerPrice: relatedBuyerQuoteItem.avgSellerPrice
                }
            }
            return eachSuggMarginBuyerQuoteItem
        })
        setSuggMarginBuyerQuoteItems([...updatedSuggMarginBuyerQuoteItems])

        const updatedBuyerQuote = { ...calculatedResult.buyerQuote, isSuggMarginApplied: isSuggMarginApplied }
        const marginLessThanSuggMarginBuyerQuoteItems = updatedSuggMarginBuyerQuoteItems.filter(eachSuggMarginQuoteItem => parseFloat(eachSuggMarginQuoteItem.bQuotMarginRate) < parseFloat(eachSuggMarginQuoteItem.suggMargin))
        if(marginLessThanSuggMarginBuyerQuoteItems.length === 0){
            updatedBuyerQuote.skipSuggMarginReasonId = null

            setBuyerQuote({ ...buyerQuote, skipSuggMarginReasonId: null })
        }

        setsuggMarginBuyerQuote(updatedBuyerQuote)
    }

    const handleQuoteMargin = (e, relatedBuyerQuoteItem) => {
        let inputMargin = e.value
        let updatedSuggMarginBuyerQuoteItems = suggMarginBuyerQuoteItems.map(eachQuoteItem => {
            if (eachQuoteItem.buyerReqItemId === relatedBuyerQuoteItem.buyerReqItemId) {
                const avgSellerPrice = eachQuoteItem.avgSellerPrice
                const bQuotListPrice = eachQuoteItem.bQuotListPrice

                const { buyerUnitPrice, discountPercent } = getMarginCalc(avgSellerPrice, bQuotListPrice, inputMargin)
                return {
                    ...eachQuoteItem,
                    bQuotMarginRate: inputMargin,
                    bQuotUnitPrice: buyerUnitPrice,
                    bQuotDiscountRate: discountPercent,
                    suggMarginChecked: e.value
                }
            }
            return eachQuoteItem
        })

        updateBuyerQuoteItemsWithSuggValues(updatedSuggMarginBuyerQuoteItems)
    }

    const handleSuggUnitPrice = (e, relatedBuyerQuoteItem) => {
        let updatedSuggMarginBuyerQuoteItems = suggMarginBuyerQuoteItems.map(eachQuoteItem => {
            if (eachQuoteItem.buyerReqItemId === relatedBuyerQuoteItem.buyerReqItemId) {
                const avgSellerPrice = eachQuoteItem.avgSellerPrice
                const bQuotListPrice = eachQuoteItem.bQuotListPrice
                const buyerUnitPrice = round(parseFloat(e.target.value), 3)

                const { discountPercent, marginPercent } = getUnitPriceCalc(bQuotListPrice, buyerUnitPrice, avgSellerPrice)
                return {
                    ...eachQuoteItem,
                    bQuotUnitPrice: e.target.value,
                    bQuotDiscountRate: discountPercent,
                    bQuotMarginRate: marginPercent
                }
            }
            return eachQuoteItem
        })

        updateBuyerQuoteItemsWithSuggValues(updatedSuggMarginBuyerQuoteItems)
    }

    const handleUnitPriceValidation = (e, relatedBuyerQuoteItem) => {
        let overridedMargin = e.target.value
        if (!overridedMargin) {
            overridedMargin = parseFloat(relatedBuyerQuoteItem.suggUnitPrice)
            dispatch(raiseToast({ severity: 'error', detail: `Margin should be entered!` }))
        }

        if (parseFloat(e.target.value) > parseFloat(relatedBuyerQuoteItem.suggUnitPrice)) {
            overridedMargin = parseFloat(relatedBuyerQuoteItem.suggUnitPrice)
            dispatch(raiseToast({ severity: 'error', detail: `Maximum suggested unit price is ${relatedBuyerQuoteItem.suggUnitPrice}` }))
        }

        if (parseFloat(e.target.value) < parseFloat(relatedBuyerQuoteItem.quotedUnitPrice)) {
            overridedMargin = parseFloat(relatedBuyerQuoteItem.quotedUnitPrice)
            dispatch(raiseToast({ severity: 'error', detail: `Minimum quoted unit price is ${relatedBuyerQuoteItem.quotedUnitPrice}` }))
        }

        let updatedSuggMarginBuyerQuoteItems = suggMarginBuyerQuoteItems.map(eachQuoteItem => {
            if (eachQuoteItem.buyerReqItemId === relatedBuyerQuoteItem.buyerReqItemId) {
                const avgSellerPrice = eachQuoteItem.avgSellerPrice
                const bQuotListPrice = eachQuoteItem.bQuotListPrice
                const buyerUnitPrice = round(parseFloat(overridedMargin), 3)

                const { discountPercent, marginPercent } = getUnitPriceCalc(bQuotListPrice, buyerUnitPrice, avgSellerPrice)
                return {
                    ...eachQuoteItem,
                    bQuotUnitPrice: overridedMargin,
                    bQuotDiscountRate: discountPercent,
                    bQuotMarginRate: marginPercent
                }
            }
            return eachQuoteItem
        })

        updateBuyerQuoteItemsWithSuggValues(updatedSuggMarginBuyerQuoteItems)
    }

    const handleBuyerQuoteSuggMargin = () => {
        const noMarginRateBuyerQuote = suggMarginBuyerQuoteItems.find(eachSuggMarginQuoteItem => !eachSuggMarginQuoteItem.bQuotMarginRate && eachSuggMarginQuoteItem.bQuotMarginRate !== 0)
        if (noMarginRateBuyerQuote) {
            return dispatch(raiseToast({ severity: 'error', detail: `Please enter margin for material ${noMarginRateBuyerQuote.materialId}` }))
        }

        const lossMarginRateBuyerQuote = suggMarginBuyerQuoteItems.find(eachSuggMarginQuoteItem => round(eachSuggMarginQuoteItem.bQuotMarginRate, 2) < round(eachSuggMarginQuoteItem.quotedMargin, 2))
        if (lossMarginRateBuyerQuote) {
            return dispatch(raiseToast({ severity: 'error', detail: `Input margin should be more than quoted margin for material ${lossMarginRateBuyerQuote.materialId}!` }))
        }

        const marginLessThanSuggMarginBuyerQuoteItems = suggMarginBuyerQuoteItems.filter(eachSuggMarginQuoteItem => parseFloat(eachSuggMarginQuoteItem.bQuotMarginRate) < parseFloat(eachSuggMarginQuoteItem.suggMargin))
        if(marginLessThanSuggMarginBuyerQuoteItems.length){
            if(!suggMarginBuyerQuote.skipSuggMarginReasonId){
                return dispatch(raiseToast({ severity: 'error', detail: `Please enter reason for not choosing suggested margin` }))
            }
        }

        const suggestedMarginQuoteItems = suggMarginBuyerQuoteItems.map(eachSuggMarginBuyerQuoteItem => {
            let suggUnitPrice = round(eachSuggMarginBuyerQuoteItem.avgSellerPrice / (1 - (eachSuggMarginBuyerQuoteItem.suggMargin / 100)), 2)
            return {...eachSuggMarginBuyerQuoteItem, bQuotMarginRate: eachSuggMarginBuyerQuoteItem.suggMargin, bQuotUnitPrice: suggUnitPrice}
        })
        const selectedMarginQuoteItems = suggMarginBuyerQuoteItems.map(eachSuggMarginBuyerQuoteItem => {
            let suggUnitPrice = round(eachSuggMarginBuyerQuoteItem.avgSellerPrice / (1 - (eachSuggMarginBuyerQuoteItem.suggMarginChecked / 100)), 2)
            return {...eachSuggMarginBuyerQuoteItem, bQuotMarginRate: eachSuggMarginBuyerQuoteItem.suggMarginChecked, bQuotUnitPrice: suggUnitPrice}
        })
        const calculateSuggestedMarginQuoteValues = calculateBuyerQuotation(buyerQuote, suggestedMarginQuoteItems)
        const calculateSelectedMarginQuoteValues = calculateBuyerQuotation(buyerQuote, selectedMarginQuoteItems)

        let marginLessConfirmText = ""
        if(marginLessThanSuggMarginBuyerQuoteItems.length){
            if (suggMarginBuyerQuote.skipSuggMarginReasonId === 1){
                let suggMarginQuoteAmount = calculateSuggestedMarginQuoteValues.buyerQuote.bQuotTotalItemAmountWithTax
                let selectedMarginQuoteAmount = calculateSelectedMarginQuoteValues.buyerQuote.bQuotTotalItemAmountWithTax
                let totalMarginProfitAmount = parseInt(suggMarginQuoteAmount - selectedMarginQuoteAmount)
                marginLessConfirmText += `If you go by suggested margin, you could have earned ${pmCompanyConfig.currencySymbol}${numberConversion(totalMarginProfitAmount)} more by applying the suggested margin! `

                if (buyerQuote.bQuotTotalItemAmountWithTax < 500000 && true){
                    marginLessConfirmText += ` Also, you wouldn't need any approvals!`
                }
            }else {
                if (buyerQuote.bQuotTotalItemAmountWithTax < 500000 && true){
                    marginLessConfirmText += ` If you go by suggested margin, you wouldn't need any of the approvals!!`
                }
            }

            marginLessConfirmText += ` Are you sure you still want to apply custom-margin?`

            confirmDialog({
                message: (
                    <div style={{ width: '350px', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                    {marginLessConfirmText}
                </div>
                ),
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: () => handleUpdatedBuyerQuoteItemsSuggMargins(suggMarginBuyerQuoteItems)
            })
    
        }else {
            handleUpdatedBuyerQuoteItemsSuggMargins(suggMarginBuyerQuoteItems)
        }
    }

    const handleBuyerQuoteMarginSuggOnHide = () => {
        setSuggMarginBuyerQuoteItems([])
        setVisibleMarginSuggestion(false)
    }

    const handleBuyerQuoteSkipSuggMarginReasonId = (e) => {
        setBuyerQuote({ ...buyerQuote, skipSuggMarginReasonId: e.target.value })
        setsuggMarginBuyerQuote({ ...suggMarginBuyerQuote, skipSuggMarginReasonId: e.target.value })
    }

    const bQuoteMarginSuggFooter = () => {
        return (
            <div className="mt-2">
                <Button label="Cancel" severity="danger" outlined onClick={handleBuyerQuoteMarginSuggOnHide} />
                <Button label="Proceed" outlined onClick={handleBuyerQuoteSuggMargin} />
            </div>
        )
    }

    let buyerReqItemIds = suggMarginBuyerQuoteItems.map(eachQuoteItem => eachQuoteItem.buyerReqItemId)
    buyerReqItemIds = _.uniqBy(buyerReqItemIds)
    const relatedBuyerReqItems = buyerReqItems.filter(eachReqItem => buyerReqItemIds.includes(eachReqItem.buyerReqItemId))

    const marginLessThanSuggMarginBuyerQuoteItems = suggMarginBuyerQuoteItems.filter(eachSuggMarginQuoteItem => parseFloat(eachSuggMarginQuoteItem.bQuotMarginRate) < parseFloat(eachSuggMarginQuoteItem.suggMargin))

    return (
        <Dialog header="Margin Suggestions" visible={visibleMarginSuggestion} style={{ width: '65vw', maxHeight: "70%" }} onHide={handleBuyerQuoteMarginSuggOnHide} footer={bQuoteMarginSuggFooter}>
            <div className="flex flex-column justify-content-between h-full" style={{ flexGrow: 1 }}>
                <div className="flex justify-content-start align-items-center">
                    <img
                        className="jaadu-img"
                        src="https://procmart-dev.s3.ap-south-1.amazonaws.com/requirementSourceDocument/b90c3f66-c047-4c57-93b7-b84ea6d4e095.gif"
                        alt="Jaadu AI"
                    />
                    <div className="ml-2">
                        <p><span className="text-base font-semibold">Jaadu</span> suggests higher margin than what's selected for the items below. Please review!</p>
                    </div>
                </div>
                <div className="mt-1">
                    {
                        relatedBuyerReqItems.map(eachReqItem => {
                            let relatedBuyerQuoteItems = suggMarginBuyerQuoteItems.filter(eachQuoteItem => eachQuoteItem.buyerReqItemId === eachReqItem.buyerReqItemId)
                            const relatedBuyerQuoteItem = relatedBuyerQuoteItems[0]

                            const relatedMaterial = materialDetails.find(eachMaterial => eachMaterial.materialId === eachReqItem.materialId)
                            const relatedBuyerReqItem = buyerReqItems.find(eachBuyerReqItem => eachBuyerReqItem.materialId === eachReqItem.materialId)
                            const productDetails = `${getProductName(relatedBuyerReqItem.brandName, relatedMaterial.productName, relatedMaterial.variantName)} | ${getProductSpecification(relatedMaterial.productSpecification, relatedMaterial.uom, relatedMaterial.uomValue)}`
                            let profit = relatedBuyerQuoteItem.suggMarginChecked ? round(relatedBuyerQuoteItem.suggMarginProfit - relatedBuyerQuoteItem.quotedMarginProfit, 0) : 0
                            let profitClass = `font-bold text-lg `
                            if (profit > 0) {
                                profitClass += `text-teal-700`
                            }
                            else if (profit = 0) {
                                profitClass += `text-red-700`
                            }
                            profit = (profit || profit === 0) ? `${pmCompanyConfig.currencySymbol}${numberConversion(profit)}` : null

                            return (
                                <div className="flex flex-row w-max" key={eachReqItem.buyerReqItemId}>
                                    <div className="flex flex-column col-12 mb-2 w-17rem lg:mb-0">
                                        <label htmlFor="" style={{ fontSize: "12px", marginBottom: "3px" }}>
                                            {`Product-${eachReqItem.materialId}`}
                                        </label>
                                        <TextInputField value={productDetails} tooltip={productDetails} tooltipOptions={{ position: 'top', showOnDisabled: true, }} disabled />
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 w-8rem lg:mb-0">
                                        <TextInputField labelText="Quoted Margin" value={`${parseFloat(relatedBuyerQuoteItem.quotedMargin)}%`} disabled />
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 w-8rem lg:mb-0">
                                        <TextInputField labelText="Suggested Margin" value={`${relatedBuyerQuoteItem.suggMargin}%`} disabled />
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 w-8rem lg:mb-0">
                                        <TextInputField labelText="Quoted Unit Price" value={parseFloat(relatedBuyerQuoteItem.quotedUnitPrice)} disabled />
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 lg:mb-0 mr-2 ml-2 w-5rem align-items-center">
                                        <label htmlFor="" style={{ fontSize: "12px" }}>
                                            P&L Diff
                                        </label>
                                        <div className="mt-2">
                                            <span className={profitClass}>{profit}</span>
                                        </div>
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 w-13rem">
                                        <label htmlFor="" style={{ fontSize: "12px", marginBottom: "3px" }}>
                                            Margin %
                                        </label>
                                        <div className='flex flex-row  align-items-center'>
                                            <Slider
                                                value={relatedBuyerQuoteItem.bQuotMarginRate}
                                                onChange={(e) => handleQuoteMargin(e, relatedBuyerQuoteItem)}
                                                min={parseFloat(relatedBuyerQuoteItem.quotedMargin)}
                                                max={relatedBuyerQuoteItem.maxSuggMargin}
                                                className={`w-full slider-margin-${eachReqItem.buyerReqItemId}`}
                                            />
                                            <Tooltip target={`.slider-margin-${eachReqItem.buyerReqItemId}`} position="top" showDelay={0} hideDelay={0}>
                                                {relatedBuyerQuoteItem.bQuotMarginRate}
                                            </Tooltip>
                                        </div>
                                        <div className='flex flex-row justify-content-between align-items-center'>
                                            <div className="">
                                                <label style={{ fontSize: "12px", marginBottom: "3px" }} >
                                                    Unit Price
                                                </label>
                                            </div>
                                            <TextInputField
                                                value={relatedBuyerQuoteItem.bQuotUnitPrice}
                                                onChange={(e) => handleSuggUnitPrice(e, relatedBuyerQuoteItem)}
                                                className='w-5rem'
                                                keyfilter="num"
                                                onBlur={(e) => handleUnitPriceValidation(e, relatedBuyerQuoteItem)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                {
                    marginLessThanSuggMarginBuyerQuoteItems.length ?
                    <div className='flex flex-row justify-content-end'>
                        <DropDownField name="skipSuggMarginReasonId" labelText="Reason for not choosing suggested margin" value={buyerQuote.skipSuggMarginReasonId} options={skipSuggMarginReasons} optionValue="skipSuggMarginReasonId" optionLabel="skipSuggMarginReason" onChange={handleBuyerQuoteSkipSuggMarginReasonId} required /> 
                    </div>
                    : null
                }
                <div className="flex justify-content-end align-items-end mb-2">
                    <p>Original Quote Value: <span className="font-bold mr-6">{buyerQuote ? numberConversion(parseInt(buyerQuote.bQuotTotalItemAmountWithTax), numberLocale) : null}</span></p>
                    <p>Current Quote Value: <span className="font-bold">{suggMarginBuyerQuote ? numberConversion(parseInt(suggMarginBuyerQuote.bQuotTotalItemAmountWithTax), numberLocale) : null}</span></p>
                </div>
            </div>
        </Dialog>
    )
}

export default BuyerQuoteMarginSuggetions